import React from "react";
import { toast } from "react-toastify";
import { Box, Button, Divider } from "@mui/material";
import { Add } from "@mui/icons-material";

import { useCustomerDetailContext } from "contexts/CustomerDetailContext";
import { useAddCustomerNotesMutation } from "store/services/customerApi";

import FormDrawer from "components/Shared/FormDrawer";

import CustomerNoteList from "./CustomerNoteList";
import CustomerNotesForm from "./CustomerNotesForm";

const CustomerNotesTab = () => {
  const [showNoteForm, setShowNoteForm] = React.useState(false);

  const [selectedNote, setSelectedNote] = React.useState(null);

  const { customerDetail } = useCustomerDetailContext();

  // RTK Query
  const [addNote, { isLoading: addingNote }] = useAddCustomerNotesMutation();

  // methods
  const handleCancelNote = () => {
    setShowNoteForm(false);
    setSelectedNote(null);
  };

  const handleAddNote = async (data) => {
    try {
      await addNote({ ...data, customerId: customerDetail?._id }).unwrap();
      toast.success("Notes successfully added!");
      handleCancelNote();
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't add notes!");
    }
  };

  return (
    <>
      <Box display="flex" justifyContent="end" padding={3}>
        {!showNoteForm && (
          <Button
            startIcon={<Add />}
            variant="outlined"
            onClick={() => setShowNoteForm(true)}
          >
            Add Note
          </Button>
        )}
      </Box>
      <Divider />
      {/* list of notes */}
      <CustomerNoteList />

      <FormDrawer
        title="Customer Notes"
        open={showNoteForm}
        onClose={handleCancelNote}
      >
        <CustomerNotesForm
          isBusy={addingNote}
          note={selectedNote}
          onSubmit={handleAddNote}
          onCancel={handleCancelNote}
        />
      </FormDrawer>
    </>
  );
};

export default CustomerNotesTab;
